import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'img',
  standalone: false
})
export class DefaultImageFallbackDirective {

  private readonly defaultFallback = 'assets/icn/generic.svg';
  private failed = false;

  constructor(private el: ElementRef<HTMLImageElement>) {
  }

  @HostListener('error')
  onError(): void {
    if (this.failed) return;
    if (this.el.nativeElement.hasAttribute('fallbackImage')) return;
    // An empty/unset src (e.g. an [src] binding still waiting on async data) fires a
    // spurious `error` event in most browsers before any request is even made — that's
    // not a real broken image, so don't burn the fallback on it; wait for a real src.
    if (!this.el.nativeElement.getAttribute('src')) return;
    this.failed = true;
    this.el.nativeElement.src = this.defaultFallback;
  }
}
